<template>
  <div class="row" v-if="can_access('stock','view')">
    <h1 class="">Securities</h1>
    <div class="col-sm-12" v-if="can_access('stock','modify')">
      <b-button class="btn-info pull-right" @click="showAddSecuritiesForm=showAddSecuritiesForm?false:true" title="Add Securities"><i :class="showAddSecuritiesForm?'fa fa-minus':'fa fa-plus'"></i></b-button>
    </div>
    <div v-if="showAddSecuritiesForm && can_access('stock','modify')">
      <AddSecuritiesForm :forceRerender="securitiesFormReRender"/>
    </div>
    <TableView :col="columns" :getData="getData" v-if="can_access('stock','view')"/>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import AddSecuritiesForm from '@/components/Accounts/AddSecurityForm';
import common from '@/assets/js/common.js';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import TableView from '@/components/Common/DataTable/Table';

export default {
  name: 'SecurityPage',
  components: { Widget, AddSecuritiesForm, DatePicker, TableView },
  mixins: [common],
  data() {
    return {
      showAddSecuritiesForm: 1,
      columns: (() => {
        const cols = [
          { title: 'Type', field: 'type', visible: 'true' },
          { title: 'Ticker', field: 'tidm', thComp: 'FilterTh', sortable: true },
          { title: 'Name', field: 'issuer_name', thComp: 'FilterTh', sortable: true },
          { title: 'Currency', field: 'currency', thComp: 'FilterTh', thStyle: { fontWeight: 'normal' }, sortable: true },
          { title: 'Exemption Start Date', field: 'stamp_duty_exemption_start_date', thComp: 'FilterTh', sortable: true},
          { title: 'Exemption End Date', field: 'stamp_duty_exemption_end_date', thComp: 'FilterTh', sortable: true},
          { title: 'ISIN', field: 'isin', thComp: 'FilterTh', sortable: true},
          { title: 'SEDOL', field: 'sedol', thComp: 'FilterTh', sortable: true},
          { title: 'CUSIP', field: 'cusip', thComp: 'FilterTh', sortable: true},
          { title: 'Exchange Name', field: 'exchange_name', thComp: 'FilterTh', tdStyle: { fontStyle: 'italic' }, sortable: true },
          { title: 'Operation', tdComp: 'tradeSecurityOpt', visible: 'true', tdStyle:{'text-align':'center'}, thStyle:{'text-align':'center'} }
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          if(!this.can_view_field('stock', col.nested?col.nested:col.field) && col.title != 'Operation') col.visible = false;
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
    };
  },
  methods: {
    securitiesFormReRender(response) {
      if(response.code==0){
        this.showAddSecuritiesForm = false;
        this.$nextTick(function(){
          this.showAddSecuritiesForm = true;
          this.$toasted.success("Successfully Added",{duration:1000});
        });
      }
    },
    async getData(query, filter) {
      const { limit = 10, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));

      this.columns.forEach(col => {
        if (query[col.field]) {
          filter[col.field] = query[col.field];
        }else if(typeof filter[col.field] != 'undefined'){
          delete filter[col.field];
        }
      });

      let uri = 'stock_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      return await this.call_axios(uri);
    }
  },
  created() {
    
  },
};
</script>